import { ScrollableAreaTabFooter } from "@ofqual/portal-components/components/ScrollableAreaTabFooter";
import {
  ScrollableAreaTab,
  ScrollableAreaTabSkeleton,
} from "@ofqual/portal-components/components/ScrollableAreaTab";
import { Typography } from "@material-ui/core";
import React, { useState } from "react";
import { DialogActionArgument, DialogActionType } from "./types";
import { RenderDialog } from "./RenderDialog";
import { ActionsItem } from "./ActionsItem";
import { useScrollToBottomRef } from "@ofqual/portal-core/core/hooks";
import { Notice } from "./notice/Notice";
import { useValidation } from "../../../hooks/useValidation";
import { NonNullableActionsState } from "../../../redux/state";

export const Actions: React.FC<{
  actionsState: NonNullableActionsState | null;
  organisationRecipientId?: string;
  disabled?: boolean;
  itemId?: string;
  isSent?: boolean;
}> = ({ disabled, actionsState, organisationRecipientId, itemId, isSent }) => {
  const [focussedDialog, setFocussedDialog] = useState<DialogActionArgument>(
    null
  );
  const { isReady, isActionsOk } = useValidation();
  const shouldShowWarning = isReady && !isActionsOk;

  const scrollRef = useScrollToBottomRef<HTMLDivElement>(actionsState?.actions);

  const footerActions = [
    {
      label: "Create action",
      dataTest: "create-action",
      action: () => setFocussedDialog(DialogActionType.CreateAction),
      disabled,
    },
  ];

  const actions = actionsState?.actions;

  return (
    <>
      {actions ? (
        <>
          <ScrollableAreaTab
            hasActions={!!footerActions.length}
            ref={scrollRef}
          >
            <>
              {actions.map((item) => (
                <ActionsItem
                  key={item.id}
                  action={item}
                  setFocussedDialog={setFocussedDialog}
                  isAOView={!!organisationRecipientId}
                  organisationRecipientId={organisationRecipientId!}
                  disabled={disabled}
                  isSent={isSent}
                />
              ))}

              {!shouldShowWarning && !actions.length && (
                <Typography
                  variant="h4"
                  style={{ textAlign: "center", textTransform: "uppercase" }}
                  color="textSecondary"
                >
                  None
                </Typography>
              )}

              {shouldShowWarning && (
                <Notice
                  onClick={() =>
                    setFocussedDialog(
                      DialogActionType.CreateActionRespondWithDocuments
                    )
                  }
                />
              )}
            </>
          </ScrollableAreaTab>
          {!organisationRecipientId && (
            /* only show the footer actions if we are on the parent view */
            <ScrollableAreaTabFooter actions={footerActions} />
          )}
          <RenderDialog
            focussedDialog={focussedDialog}
            onClose={() => setFocussedDialog(null)}
            organisationRecipientId={organisationRecipientId}
            itemId={itemId}
          />
        </>
      ) : (
        <ScrollableAreaTabSkeleton hasActions={!!footerActions.length} />
      )}
    </>
  );
};
